module.exports = __webpack_public_path__ + "img/deluxe-vehicle-filter-welcome-background-kia.37484adf.png";